<template>
  <div>
    <div
      :class="labelValue ? 'rounded-t-md' : 'rounded-md'"
      class="relative h-36 cursor-pointer bg-gray-100 flex items-center justify-center border border-dashed border-slate-300"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @click="triggerInput">
      <template v-if="imagePreview">
        <a
          :href="imagePreview"
          target="_blank"
          rel="noopener noreferrer"
          class="absolute inset-0 rounded-md overflow-hidden">
          <img
            :src="imagePreview"
            alt="Preview"
            class="w-full h-full object-cover"
            :class="labelValue ? 'rounded-t-md' : 'rounded-md'" />
        </a>
      </template>

      <template v-else>
        <div class="text-gray-400 text-5xl">+</div>
      </template>

      <TableIconButton
        v-if="imagePreview"
        icon="fa-x"
        class="absolute top-2 right-2 text-red-500"
        @click="removeImage()" />

      <input type="file" ref="fileInput" accept="image/*" @change="handleFileChange" class="hidden" />
    </div>

    <div v-if="labelValue" class="h-[40px] border rounded-b-md flex justify-center items-center">
      <p class="p-1 font-bold">{{ labelValue }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  src: String,
  modelValue: {
    type: Object,
    default: {},
  },
  label: String,
})

const imagePreview = ref(props.src)
const hover = ref(false)
const labelValue = ref('')
const fileInput = ref(null)

const removeImage = () => {
  imagePreview.value = null
  emit('update:modelValue', null)
}

const handleFileChange = (event) => {
  const file = event.target.files[0]
  if (file) {
    imagePreview.value = URL.createObjectURL(file)
    emit('update:modelValue', file)
  }
}

const triggerInput = () => {
  fileInput.value.click()
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (typeof newValue === 'string') {
      imagePreview.value = newValue
      return
    }

    try {
      imagePreview.value = newValue ? URL.createObjectURL(newValue) : null
    } catch (error) {
      imagePreview.value = null
    }
  },
  { immediate: true }
)

onMounted(() => {
  labelValue.value = props.label
})
</script>
